export default __webpack_public_path__ + "static/media/vault-flow.730e0c98.png";